'use client';
import { create } from 'zustand';

export type BooleanValueState = {
  value: boolean;
  setValue: (value: boolean) => void;
};

/** A store to record the state of Next Hydration */

export const useNextHydratedStore = create<BooleanValueState>((set) => ({
  value: false,
  setValue: (value: boolean) => set({ value }),
}));
